import { send } from "../send";
import { System } from "./Modular/system"; // 企业平台系统模块
import { Deploy } from "./Modular/deploy"; // 企业平台配置模块
import { Enum } from "./Modular/enum"; // 企业模块枚举模块
import { Report } from "./Modular/report"; // 企业平台报表模块
import { Warn } from "./Modular/warn"; // 企业平台告警模块
import { Event } from "./Modular/event"; // 企业平台事件模块(危废管理)
import { Info } from "./Modular/info"; // 企业平台信息模块
import { Park } from "./Park/park"; // 园区平台数据模块
import { BigData } from "./Modular/bigData"; // 大数据模块
import { Waste } from "./Modular/waste"; // 危废管理
import { newscreen } from "./Modular/newscreen"; // 新大屏接口

import { A_Company } from "./Admin/company"; // 园区后台企业添加模块
import { A_User } from "./Admin/user"; // 园区后台企业添加模块
import { A_Park } from "./Admin/systemPark"; // 园区后台 系统管理 园区管理

export const api = {
    Login: {
        getAuthCode(parmas, expend) {
            return send("GET", "/api/user/getAuthCode", parmas, expend)
        },
        userLogin(parmas, expend) {
            return send("POST", "/api/user/loginIn", parmas, expend)
        }
    },
    System,
    Deploy,
    Enum,
    Info,
    Park,
    A_Company,
    A_User,
    Report,
    Warn,
    Event,
    A_Park,
    BigData,
    Waste,
    newscreen
}